import { Box, Grid2, Typography } from '@mui/material'
import { Page_Padding } from '../../shared/constants'
import Heading, { ImgText } from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import { SummerCampImages } from '../../assets/img/summercamp/SummerCampImages'
import useResponsive from '../../shared/utils/Responsive'
import { getImageUrl } from '../../shared/utils/getImageUrl'

const HeroSection = ({ bottomData, heroData }) => {
    const isMediumScreen = useResponsive("md");
    const RederHeroList = ({ heading, subheading }) => (
        <>
            <Typography variant='subtitle1' fontWeight={600} dangerouslySetInnerHTML={{ __html: heading }} />
            <Typography variant='body2' fontWeight={300} dangerouslySetInnerHTML={{ __html: subheading }} />


        </>
    )
    const renderContent = (
        <>
            <Box sx={{ width: { xs: "90%", sm: "90%", md: "70%" }, mx: "auto" }} px={Page_Padding} pt={"10%"} textAlign={"center"}>
                <ImgText text={heroData?.heading} center />
                <CustomDivider size={"0.5rem"} />
                <Typography variant='subtitle1' fontWeight={300} dangerouslySetInnerHTML={{ __html: heroData?.description }} />
                {/* A summer camp is a specially designed program for children during their vacation, where they participate in fun, creative, educational, and physical activities in a structured and engaging environment. It gives children an opportunity to learn new skills, explore interests, make friends, and stay active, all while enjoying their holidays meaningfully
                </Typography> */}

            </Box>
            <Box px={Page_Padding}>
                <Grid2 container>
                    <Grid2 children size={{ xs: 0, sm: 0, md: 1 }} />
                    <Grid2 children size={{ xs: 6, sm: 5, md: 3 }}>
                        <Box
                            component={"img"}
                            src={SummerCampImages.BalloonImage}
                            sx={{ width: "15%", borderRadius: 0 }}
                        />
                        <RederHeroList heading={heroData?.heroList[0]?.heading} subheading={heroData?.heroList[0]?.subheading} />
                        {/* <Typography variant='subtitle1' fontWeight={600}>Creative learning</Typography>
                        <Typography variant='body2' fontWeight={300} >Art, craft, storytelling, DIY activities</Typography> */}

                    </Grid2>
                    <Grid2 children size={{ xs: 0, sm: 1, md: 5 }} />
                    <Grid2 size={{ xs: 6, sm: 5, md: 3 }}>
                        <Box
                            component={"img"}
                            src={SummerCampImages.BalloonImage}
                            sx={{ width: "15%", borderRadius: 0 }}
                        />
                        <RederHeroList heading={heroData?.heroList[1]?.heading} subheading={heroData?.heroList[1]?.subheading} />
                        {/* <Typography variant='subtitle1' fontWeight={600}>Skill development</Typography>
                        <Typography variant='body2' fontWeight={300} >Communication, confidence, teamwork</Typography> */}

                    </Grid2>
                </Grid2>
                <CustomDivider size={"1rem"} />
                <Grid2 container>
                    <Grid2 children size={{ xs: 0, sm: 0.5, md: 0.5 }} />
                    <Grid2 children size={{ xs: 6, sm: 5, md: 3 }}>
                        <Box
                            component={"img"}
                            src={SummerCampImages.BalloonImage}
                            sx={{ width: "15%", borderRadius: 0 }}
                        />
                        <RederHeroList heading={heroData?.heroList[2]?.heading} subheading={heroData?.heroList[2]?.subheading} />
                        {/* <Typography variant='subtitle1' fontWeight={600} textAlign={"start"}>Fun engagement</Typography>
                        <Typography variant='body2' fontWeight={300} >Challenges, theme days, group activities</Typography> */}

                    </Grid2>
                    <Grid2 children size={{ xs: 0, sm: 1.5, md: 5 }} />
                    <Grid2 size={{ xs: 6, sm: 5, md: 3 }}>
                        <Box
                            component={"img"}
                            src={SummerCampImages.BalloonImage}
                            sx={{ width: "15%", borderRadius: 0 }}
                        />
                        <RederHeroList heading={heroData?.heroList[3]?.heading} subheading={heroData?.heroList[3]?.subheading} />
                        {/* <Typography variant='subtitle1' fontWeight={600}>Physical activities</Typography>
                        <Typography variant='body2' fontWeight={300} >Dance, yoga, games, movement exercises</Typography> */}

                    </Grid2>

                </Grid2>
                <CustomDivider />
                <CustomDivider />
                <Heading Heading={bottomData?.heading} center />
                <Typography variant='body1' textAlign={"center"} fontWeight={300} dangerouslySetInnerHTML={{ __html: bottomData?.description }} />


                {/* >Started as MySkool Summer camp in the year 2023, we have been conducting highly engaging apartment based summer camps across Bangalore, designed specially for children who love to create, explore and learn through fun. Our camp brings together a thoughtfully curated blend of creative activities, art & craft,personality development sessions, dance, yoga, and physical challenges</Typography> */}
                {/* <Typography variant='body1' mt={2} textAlign={"center"} fontWeight={300}>We believe summers should be more than screens. Our program is built to help children discover new skills, build confidence, make friends, and stay active, all within the comfort and safety of their own community apartment</Typography> */}

            </Box>
        </>
    )
    return (
        <Box>
            <Box

                sx={{
                    width: "100%",
                    height: "auto",
                    aspectRatio: { xs: "16/8", sm: "16/9", md: "16/11.5" },
                    backgroundImage: `url(${getImageUrl(heroData?.imageUrl)})`,
                    //  backgroundImage: `url(${SummerCampImages.HeroBgImage})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100%",


                }}
            >

                {
                    !isMediumScreen &&
                    renderContent
                }

            </Box>

            {
                isMediumScreen && renderContent
            }




        </Box>
    )
}

export default HeroSection
